import Controller, { inject } from '@ember/controller';
import { scheduleOnce } from '@ember/runloop';
import { service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';

import $ from 'jquery';

import type { Service } from 'webapp-types';

import type DesignerController from 'webapp/controllers/designer';

import type BoardState from 'webapp/models-custom/board-state';
import type BlockRecord from 'webapp/models/block';

export default class DesignerBoardBlockController extends Controller {
	@service('model-manager/blocks') declare mmBlocksService: Service.ModelManager.Blocks;

	@inject('designer') declare designerController: DesignerController;

	// set from route setupController
	@tracked blockId = '';

	get boardState(): BoardState | null {
		return this.designerController.boardState;
	}

	constructor() {
		// eslint-disable-next-line prefer-rest-params
		super(...arguments);
		this.blockChanged();
	}

	@cached
	get block(): BlockRecord | null {
		let block;
		if (this.blockId) {
			block = this.mmBlocksService.findRecord(this.blockId);
			if (!block) {
				this.selectBlock(null);
			}
		}

		return block || null;
	}

	selectBlock(blockId: string | null): void {
		if (this.boardState) {
			this.boardState.selectBlock(blockId);
		}
		this.blockId = blockId || '';
		this.blockChanged();
	}

	boardDataLoaded(boardId: string): void {
		if (this.block && boardId === String(this.block.boardId)) {
			this.selectBlock(this.block.id);
		}
	}

	// scrolling to block whenever it's been changed
	scrollToBlock(blockId: string): void {
		const blockEl = $('#b' + blockId).parent('a');
		if (blockEl) {
			blockEl.trigger('block.select');
		}
	}

	blockChanged(): void {
		if (this.block?.id) {
			scheduleOnce('afterRender', this, this.scrollToBlock, this.block.id);
		}
	}
}
